import React from 'react';
import { Modal } from 'reactstrap';
import { useModal } from 'contexts/ModalContext';

interface IModalProps {
  isOpen: boolean;
  modalName: string;
  isErrorMessage: boolean;
  toggleModal: (modalName: string) => void;
  children: any;
}

const ModalComp = ({
  isOpen,
  toggleModal,
  modalName,
  isErrorMessage = false,
  ...props
}: IModalProps) => {
  const { setModal } = useModal();

  const closeModal = () => {
    setModal({ isOpen: false });
  };

  return (
    <Modal
      className="modal-dialog-centered"
      contentClassName={isErrorMessage ? 'bg-gradient-danger' : ''}
      isOpen={isOpen}
      toggle={() => toggleModal(modalName)}
    >
      <div className="modal-header">
        <button
          aria-label="Close"
          className="close"
          data-dismiss="modal"
          onClick={
            () => typeof toggleModal === 'function' ? toggleModal(modalName) : closeModal()
            // eslint-disable-next-line react/jsx-curly-newline
          }
          type="button"
        >
          <span aria-hidden>×</span>
        </button>
      </div>
      <div className="modal-body">{props.children}</div>
      <div className="modal-footer">&nbsp;</div>
    </Modal>
  );
};

export default ModalComp;
